import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEarRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 28,
	viewBox: "0 0 17 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.306059 15.1951C-0.21577 22.4544 -0.692839 26.0865 4.49531 26.4595C9.68345 26.8324 16.1556 30.3779 16.6775 23.1185C17.1993 15.8592 8.31907 0.310147 4.17468 0.0122306C-1.01347 -0.360715 0.827888 7.93581 0.306059 15.1951Z",
		fill: "#FFFCD8"
	})
});
export default SvgEarRight;
